import React from 'react';
import { Box, Button, Container, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Alert, CircularProgress, TextField } from '@mui/material';
import { CalendarMonth as CalendarMonthIcon } from '@mui/icons-material';
import MainLayout from '../../../components/layout/MainLayout';
import { staffApi, StaffAttendanceRow } from '../api';

const AttendancePage: React.FC = () => {
  const [attendance, setAttendance] = React.useState<StaffAttendanceRow[]>([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState('');
  const [month, setMonth] = React.useState(new Date().toISOString().slice(0, 7));

  React.useEffect(() => {
    loadAttendance();
  }, [month]);

  const loadAttendance = async () => {
    setLoading(true);
    setError('');
    try {
      const data = await staffApi.monthlyAttendance(month);
      setAttendance(data);
    } catch (err: any) {
      setError(err.message || 'Failed to load attendance');
    } finally {
      setLoading(false);
    }
  };

  return (
    <MainLayout>
      <Container maxWidth="lg" sx={{ py: 3 }}>
        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" alignItems={{ xs: 'flex-start', sm: 'center' }} spacing={2} sx={{ mb: 3 }}>
          <Box>
            <h2 style={{ margin: 0 }}>Staff Attendance</h2>
            <p style={{ margin: '4px 0 0 0', color: '#666', fontSize: '14px' }}>Mark and view monthly attendance records</p>
          </Box>
          <TextField
            label="Month"
            type="month"
            value={month}
            onChange={(e) => setMonth(e.target.value)}
            InputLabelProps={{ shrink: true }}
            sx={{ width: 200 }}
          />
        </Stack>

        {error ? <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert> : null}

        <TableContainer component={Paper}>
          {loading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
              <CircularProgress />
            </Box>
          ) : attendance.length === 0 ? (
            <Box sx={{ p: 2, textAlign: 'center' }}>No attendance records for this month</Box>
          ) : (
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Employee Code</TableCell>
                  <TableCell>Name</TableCell>
                  <TableCell>Department</TableCell>
                  <TableCell>Designation</TableCell>
                  <TableCell align="center">Present (P)</TableCell>
                  <TableCell align="center">Absent (A)</TableCell>
                  <TableCell align="center">Leave (L)</TableCell>
                  <TableCell align="center">Total Days</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {attendance.map((row) => (
                  <TableRow key={row.staffId} hover>
                    <TableCell>{row.employeeCode}</TableCell>
                    <TableCell>{row.name}</TableCell>
                    <TableCell>{row.department || '-'}</TableCell>
                    <TableCell>{row.designation || '-'}</TableCell>
                    <TableCell align="center">{row.present}</TableCell>
                    <TableCell align="center">{row.absent}</TableCell>
                    <TableCell align="center">{row.leave}</TableCell>
                    <TableCell align="center">{row.total}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </TableContainer>
      </Container>
    </MainLayout>
  );
};

export default AttendancePage;
